export default __webpack_public_path__ + "static/tips-f0119e890ee3fd34354df8ad1b9f5dd7.jpg";